export function cleanFileName(input: string): string {
  // Strip all non-alphanumeric chars out of file names, because they're super picky (on some platforms)
  // If it introduces two underscores, replace them with a single underscore.
  return input.replace(/[^\w\d-.]/g, '_').replace(/_+/g, '_');
}

export function cleanExcelSheetName(input: string): string {
  // Excel sheet names have limitations on both characters and length
  return input
    .replace(/[:/\\?*[\]]/g, '_')
    .replace(/_+/g, '_')
    .substring(0, 30);
}

// uniqueSheetName appends a numerical suffix to sheet names if they already exist, as Excel won't allow conflicts.
export function uniqueSheetName(
  baseSheetName: string,
  existing: readonly string[],
): string {
  let sheetName = baseSheetName;
  let i = 2;
  while (existing.includes(sheetName)) {
    sheetName = `${baseSheetName} (${i})`;
    i++;
  }
  return sheetName;
}
